import { ReactNode } from "react";

interface Feature {
  icon: ReactNode;
  title: string;
}

interface FeatureIntroProps {
  title: string;
  subtitle: string;
  features: Feature[];
  buttonText: string;
  onButtonClick: () => void;
}

const FeatureIntro = ({
  title,
  subtitle,
  features,
  buttonText,
  onButtonClick,
}: FeatureIntroProps) => {
  return (
    <div className="w-full text-center">
      {/* Main Heading */}
      <h1 className="text-xl uppercase text-center tracking-normal text-gray-700 mb-4 font-optima">
        {title}
      </h1>

      {/* Subtitle */}
      <p className="text-gray-600 mb-12 leading-relaxed">
        {subtitle}
      </p>

      {/* Features List */}
      <div className="space-y-6 mb-16">
        {features.map((feature, index) => (
          <div key={index} className="flex items-center space-x-4 text-left">
            <div className="flex-shrink-0">{feature.icon}</div>
            <p className="text-gray-700 text-sm leading-relaxed break-words">
              {feature.title}
            </p>
          </div>
        ))}
      </div>

      {/* CTA Button */}
      <button
        onClick={onButtonClick}
        className="w-56 h-12 max-w-xs bg-black text-white py-3 px-6 rounded-full font-medium text-sm uppercase tracking-wider hover:bg-gray-800 transition-colors"
      >
        {buttonText}
      </button>
    </div>
  );
};

export default FeatureIntro;